import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import schema from './schema';
import View from './View';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  return (
    <>
      <View {...props} />

      {selected && (
        <SidebarPortal selected={selected}>
          <BlockDataForm
            schema={schema(props)}
            title="Button Row Block"
            onChangeField={(id, value) =>
              onChangeBlock(block, { ...data, [id]: value })
            }
            onChangeBlock={onChangeBlock}
            block={block}
            formData={data}
          />
        </SidebarPortal>
      )}
    </>
  );
};

export default Edit;
